import { useEffect } from 'react';
import { reloadUserSession } from '@jwp/ott-common/src/utils/reloadUserSession';

export const useReloadUserSession = () => {
  useEffect(() => {
    const handleBrowserFocus = async () => {
      await reloadUserSession();
    };

    window.addEventListener('focus', handleBrowserFocus);

    return () => {
      window.removeEventListener('focus', handleBrowserFocus);
    };
  }, []);
};
